import type { ComponentProps } from 'react';
import React from 'react';
import NextImage from 'next/image';
import { Box } from '@chakra-ui/react';

type BannerImageProps = ComponentProps<typeof NextImage>;

const BannerImage = (props: BannerImageProps) => {
  return (
    <Box
      position="relative"
      width="100%"
      height="100%"
      display="block"
      minHeight={{
        base: '100vw',
        mobile: '100vw',
        tablet: '600px',
      }}
    >
      <NextImage
        {...props}
        fill
        sizes="(max-width: 480px) 100vw, (max-width: 768px) 100vw, 1920px"
        style={{
          objectFit: 'cover',
          objectPosition: 'center',
        }}
      />
    </Box>
  );
};

export default BannerImage;
